var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AttributeFilterService } from 'app/services/attribute-filter.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { EditService } from 'app/services/edit.service';
import { FishboneService } from 'app/services/fishbone.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
var FeatMapToolsComponent = /** @class */ (function () {
    function FeatMapToolsComponent(activityService, attrFilterService, attrIndexService, editService, fishboneService, flipRoadService, layerService, mapControlsService, mainDataService, mapService, iMapService, mapLayerService, mapSharedService, modalService, reportService) {
        this.activityService = activityService;
        this.attrFilterService = attrFilterService;
        this.attrIndexService = attrIndexService;
        this.editService = editService;
        this.fishboneService = fishboneService;
        this.flipRoadService = flipRoadService;
        this.layerService = layerService;
        this.mapControlsService = mapControlsService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.iMapService = iMapService;
        this.mapLayerService = mapLayerService;
        this.mapSharedService = mapSharedService;
        this.modalService = modalService;
        this.reportService = reportService;
        this.mapType = 'data';
        this.showEditBtn = true;
        this.isMapEditing = false;
        this.mapEditable = false;
        this.mapEditDisableReason = '';
        // showTopoModeToggle = false;
        // isNetworkTopoOn = true; // For network editing: keep topoMode or not
        this.showAddBtn = false;
        this.isAddRecordOn = false;
        this.showInteractiveFishbone = false;
        this.isInteractiveFishboneDisabled = false;
        this.isInteractiveFishboneOn = false;
        this.showSsapLinkButton = false;
        this.showLabelPainter = false;
        this.isLabelPainterDisabled = false;
        this.isLabelPainterClean = true;
        this.isLabelPainterOn = false;
    }
    FeatMapToolsComponent.prototype.checkMapEditToggleEnabled = function () {
        var editable = true;
        this.mapEditDisableReason = '';
        // If map is already in editing mode, always enable toggle to stop editing
        if (this.isMapEditing) {
            // return true;
        }
        // If map is not in editing mode, check if editing can be enabled
        else {
            var editModeDisabled = this.editService.checkEditModeDisabled();
            var selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
            if (editModeDisabled) {
                this.mapEditDisableReason = editModeDisabled || '';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            else if (!selectedLayer) {
                this.mapEditDisableReason = 'No layer is selected.';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            else if (selectedLayer.isFishbone) {
                this.mapEditDisableReason = 'TODO: fishbone';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            else if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
                this.mapEditDisableReason = 'Editting is disabled for published layers.';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            else if (this.activityService.isDataSample.getValue() !== false) {
                this.mapEditDisableReason = 'Editing is turned off while data is sampled.';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            // TODO
            // if (!this.rightClickFeature || this.isMapEditing) {
            // 	return false;
            // }
            // let isSelfAgency = null;
            // if (this.rightClickFeature) {
            // 	// Collaborative: Check if feature belongs to same agency as customer
            // 	if (this.enableDiscrepancyAgencyRule && this.selectedLayer.isFishbone !== true && this.selectedLayer.category.isCollaborative) {
            // 		const prop = this.rightClickFeature.getProperties();
            // 		isSelfAgency = this.isSelfAgency(prop[this.attrKey]);
            // 	}
            // }
            // if (isSelfAgency !== null && isSelfAgency !== true) {
            // 	this.mapEditDisableReason = 'Only features that belong to current agency can be edited';
            // 	return false;
            // }
            else if (!this.activityService.mapFilterBS.getValue().isOn) {
                this.mapEditDisableReason = 'Please turn on map filter to start editing.';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            else if (this.attrFilterService.attrFilters.getValue().filters.filter(function (f) { return f && f.filter; }).length) {
                this.mapEditDisableReason = 'Remove attribute filters to start map editing';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
                // const data: ConfirmModalData = {
                // 	message: 'Attribute filters will be removed to enable topology editing. Do you wish to continute?'
                // };
                // const options = this.modalService.confirmModalOptions;
                // options.data = data;
                // const res = await this.modalService.openModalWindow(ConfirmModalComponent, options);
                // if (!res) {
                // 	return;
                // } else {
                // 	// this.clearAttrFilters();
                // 	await this.getData(null, {
                // 		keepEditedData: true,
                // 		keepPrevColumns: true
                // 	});
                // }
            }
            else if (this.isLabelPainterOn) {
                this.mapEditDisableReason = 'Please turn off labeling to start map editing.';
                // this.mapEditDisabled = true;
                // return false;
                editable = false;
            }
            // this.mapEditDisabled = false;
            // return true;
        }
        if (this.mainDataService.dataEditableBS.getValue().editable !== editable) {
            this.mainDataService.dataEditableBS.next({
                editable: editable
            });
        }
        this.mapEditable = editable;
        return editable;
    };
    // toggleMapEditing() {
    // 	if (!this.checkMapEditToggleEnabled()) {
    // 		return;
    // 	}
    // 	this.isMapEditing = !this.isMapEditing;
    // 	if (this.mapType === 'data') {
    // 		this.mapService.mapEditing.next({
    // 			isOn: this.isMapEditing,
    // 			source: 'control'
    // 		});
    // 	}
    // }
    FeatMapToolsComponent.prototype.checkShowEditBtn = function () {
        this.showEditBtn = this.contentMenuItemKey === 'live';
    };
    FeatMapToolsComponent.prototype.clickSingleFishbone = function () {
        if (this.isInteractiveFishboneDisabled) {
            return;
        }
        this.isInteractiveFishboneOn = !this.isInteractiveFishboneOn;
        if (this.isInteractiveFishboneOn) {
            this.startSingleFishbone();
        }
        else {
            this.stopSingleFishbone();
        }
    };
    FeatMapToolsComponent.prototype.startSingleFishbone = function () {
        this.fishboneService.interactiveFishboneSubject.next('start');
    };
    FeatMapToolsComponent.prototype.stopSingleFishbone = function () {
        this.fishboneService.interactiveFishboneSubject.next('stop');
    };
    FeatMapToolsComponent.prototype.clickLabelPainter = function () {
        if (this.isLabelPainterDisabled) {
            return;
        }
        this.isLabelPainterOn = !this.isLabelPainterOn;
        if (this.isLabelPainterOn) {
            this.startLabelPainter();
        }
        else {
            this.stopLabelPainter();
        }
    };
    FeatMapToolsComponent.prototype.clickFlipRoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.flipRoadService.flipRoadAttrs()];
                    case 1:
                        rsp = _a.sent();
                        if (!rsp || !rsp.cancel) {
                            this.flipRoadService.flipRoadSubject.next({
                                geom: true,
                                transposeCols: rsp.cols
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FeatMapToolsComponent.prototype.toggleAddressesOnRoadMode = function () {
        // const mode = this.mapService.addressesOnRoadModeBS.getValue();
        this.mapService.ssapRclLinkModeBS.next({
            isOn: this.isSsapRclModeOn //!mode.isOn
        });
    };
    // #region Data map functions
    FeatMapToolsComponent.prototype.startLabelPainter = function () {
        this.mapService.labelPainerSubject.next('start');
    };
    FeatMapToolsComponent.prototype.stopLabelPainter = function () {
        this.mapService.labelPainerSubject.next('stop');
    };
    FeatMapToolsComponent.prototype.add = function () {
        this.mapService.addNewGeomSubject.next();
    };
    // #endregion
    // toggleNetworkTopoMode() {
    // 	this.isNetworkTopoOn = !this.isNetworkTopoOn;
    // 	this.activityService.networkTopoMode.next({
    // 		isOn: this.isNetworkTopoOn
    // 	});
    // }
    FeatMapToolsComponent.prototype.checkShowAddBtn = function () {
        this.showAddBtn = this.isMapEditing;
    };
    FeatMapToolsComponent.prototype.checkShowInteractiveFishbone = function () {
        var map = this.map;
        var withinRange = this.mapReso <= this.mapLayerService.interactiveFishboneReso;
        if (!withinRange) {
            this.showInteractiveFishbone = false;
            return;
        }
        var hasCenterlineLayer = false;
        var hasAddressLayer = false;
        // Check selected layer
        var selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
        if (selectedLayer) {
            if (selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
                hasCenterlineLayer = true;
            }
            if (selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
                hasAddressLayer = true;
            }
        }
        // Check ref layer
        var refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
        var refCateCode = refLayer.getProperties()[this.attrIndexService.refLayerCodeKey];
        if (refCateCode === this.attrIndexService.cateCodeCenterline) {
            hasCenterlineLayer = true;
        }
        if (refCateCode === this.attrIndexService.cateCodeAddress) {
            hasAddressLayer = true;
        }
        if (hasCenterlineLayer && hasAddressLayer) {
            this.showInteractiveFishbone = true;
            return;
        }
        this.showInteractiveFishbone = false;
    };
    FeatMapToolsComponent.prototype.checkInteractiveFishboneDisable = function () {
        this.isInteractiveFishboneDisabled = this.isMapEditing;
    };
    FeatMapToolsComponent.prototype.checkShowSsapLink = function () {
        if (this.mapType === 'report') {
            this.showSsapLinkButton = false;
            return;
        }
        var selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
        if (!selectedLayer) {
            this.showSsapLinkButton = false;
            return;
        }
        if (selectedLayer.category.code !== this.attrIndexService.cateCodeAddress && selectedLayer.category.code !== this.attrIndexService.cateCodeCenterline) {
            this.showSsapLinkButton = false;
            return;
        }
        this.showSsapLinkButton = true;
    };
    FeatMapToolsComponent.prototype.checkShowLabelPainter = function () {
        var map = this.map;
        var isShow = false;
        var withinLabelRange = this.mapReso <= this.mapLayerService.labelPainterReso;
        if (!withinLabelRange) {
            isShow = false;
            return isShow;
        }
        // Check selected layer
        var selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
        if (selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
            isShow = true;
            return isShow;
        }
        // Check ref layer
        var refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
        var refCateCode = refLayer.getProperties()[this.attrIndexService.refLayerCodeKey];
        if (refCateCode === this.attrIndexService.cateCodeCenterline) {
            isShow = true;
            return isShow;
        }
        return isShow;
    };
    FeatMapToolsComponent.prototype.checkLabelPainterDisable = function () {
        this.isLabelPainterDisabled = this.isMapEditing;
    };
    FeatMapToolsComponent.prototype.checkShowFlipRoad = function () {
        // const editModeDisabled = this.editService.checkEditModeDisabled();
        // if (editModeDisabled) {
        // 	this.showFlipRoad = false;
        // 	return;
        // }
        // const layer = this.activityService.selectedLayerBS.getValue();
        // if (!layer.layer || layer.layer.category.code !== this.attrIndexService.cateCodeCenterline) {
        // 	this.showFlipRoad = false;
        // 	return;
        // }
        // const currentCard = this.activityService.currentCardBS.getValue();
        // if (!currentCard || !currentCard.id) {
        // 	this.showFlipRoad = false;
        // 	return;
        // }
        // if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
        // 	this.showFlipRoad = false;
        // 	return;
        // }
        // if (this.activityService.isDataSample) {
        // 	this.showFlipRoad = false;
        // 	return;
        // }
        var enable = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
        var currentCard = this.activityService.currentCardBS.getValue();
        if (!currentCard || !currentCard.id) {
            enable = false;
        }
        this.showFlipRoad = enable;
    };
    // private checkShowTopoModeToggle() {
    // 	const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
    // 	if (this.isMapEditing && selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
    // 		this.showTopoModeToggle = true;
    // 	} else {
    // 		this.showTopoModeToggle = false;
    // 	}
    // }
    FeatMapToolsComponent.prototype.checkCateEditable = function (cateCode, isArea) {
        var enable = true;
        var editModeDisabled = this.editService.checkEditModeDisabled();
        var layer = this.activityService.selectedLayerBS.getValue();
        if (editModeDisabled) {
            enable = false;
        }
        else if (this.mainDataService.contentMenuItemKeyBS.getValue() === 'published') {
            enable = false;
        }
        else if (!layer.layer || (layer.layer.category.code !== cateCode && !isArea) || (isArea && layer.layer.category.geomType !== 'AREA')) {
            enable = false;
        }
        else if (this.activityService.isDataSample.getValue() !== false) {
            enable = false;
        }
        if (!this.activityService.mapFilterBS.getValue().isOn) {
            enable = false;
        }
        // const mapReso = this.map.olMap.getView().getResolution();
        // switch (cateCode) {
        // 	case this.attrIndexService.cateCodeAddress:
        // 		if (mapReso) {
        // 		}
        // 		break;
        // 	case this.attrIndexService.cateCodeCenterline:
        // 		break;
        // 	default:
        // 		break;
        // }
        //
        return enable;
    };
    FeatMapToolsComponent.prototype.checkShowLineSplit = function () {
        this.showSplitTool = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
    };
    FeatMapToolsComponent.prototype.checkShowLineMerge = function () {
        // TODO
        this.showMergeTool = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
    };
    FeatMapToolsComponent.prototype.checkShowA3i = function () {
        this.showA3iWizard = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
    };
    FeatMapToolsComponent.prototype.checkShowAddressManage = function () {
        this.showAddressManage = this.checkCateEditable(this.attrIndexService.cateCodeAddress);
    };
    FeatMapToolsComponent.prototype.checkShowAddressRelocate = function () {
        this.showAddressRelocate = this.checkCateEditable(this.attrIndexService.cateCodeAddress);
    };
    FeatMapToolsComponent.prototype.checkShowGeomEdit = function () {
        this.showLineGeomEditWizard = this.checkCateEditable(this.attrIndexService.cateCodeCenterline);
        this.showBdryEditWizard = this.checkCateEditable(null, true); // && !this.activityService.editRecordListBS.getValue().ids.length;
    };
    FeatMapToolsComponent.prototype.setDataMapConfigs = function () {
        var _this = this;
        var isInit = true;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) { return _this.map = data; });
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (l) {
            var map = _this.map;
            if (!map) {
                return;
            }
            _this.showLabelPainter = _this.checkShowLabelPainter();
            _this.checkShowInteractiveFishbone();
            // this.checkShowTopoModeToggle();
            _this.checkShowSsapLink();
            _this.checkShowFlipRoad();
            _this.checkShowLineSplit();
            _this.checkShowLineMerge();
            _this.checkShowA3i();
            _this.checkShowAddressManage();
            _this.checkShowAddressRelocate();
            _this.checkShowGeomEdit();
        });
        this.isDataSampleSub = this.activityService.isDataSample.subscribe(function (data) {
            _this.checkShowGeomEdit();
            _this.checkShowFlipRoad();
            _this.checkShowLineSplit();
            _this.checkShowLineMerge();
            _this.checkShowA3i();
            _this.checkShowAddressManage();
            _this.checkShowAddressRelocate();
        });
        this.mapFilterSub = this.activityService.mapFilterBS.subscribe(function (data) {
            _this.checkShowGeomEdit();
            _this.checkShowFlipRoad();
            _this.checkShowLineSplit();
            _this.checkShowLineMerge();
            _this.checkShowA3i();
            _this.checkShowAddressManage();
            _this.checkShowAddressRelocate();
        });
        this.refLayerChangeSub = this.activityService.bgRefLayerChange.subscribe(function () {
            var map = _this.map;
            if (!map) {
                return;
            }
            _this.showLabelPainter = _this.checkShowLabelPainter();
            _this.checkShowInteractiveFishbone();
        });
        this.labelPainterSub = this.mapService.labelPainerSubject.subscribe(function (data) {
            if (data === 'start') {
                _this.isLabelPainterOn = true;
                _this.isLabelPainterClean = false; // TODO
            }
            else if (data === 'stop') {
                _this.isLabelPainterOn = false;
            }
            else if (data === 'clear') {
                _this.isLabelPainterClean = true;
            }
        });
        this.interactiveFBSub = this.fishboneService.interactiveFishboneSubject.subscribe(function (data) {
            if (data === 'start') {
                _this.isInteractiveFishboneOn = true;
            }
            else if (data === 'stop') {
                _this.isInteractiveFishboneOn = false;
            }
        });
        this.addressesOnRoadModeSub = this.mapService.ssapRclLinkModeBS.subscribe(function (data) {
            _this.isSsapRclModeOn = data.isOn;
        });
        this.mapEditingSub = this.mapService.mapEditing.subscribe(function (data) {
            if (!isInit && data) {
                // if (data.source !== 'control') {
                _this.isMapEditing = data.isOn;
                // Label painter
                if (_this.isMapEditing && _this.isLabelPainterOn) {
                    _this.stopLabelPainter();
                }
                if (_this.isMapEditing && _this.isInteractiveFishboneOn) {
                    _this.stopSingleFishbone();
                }
                // }
                _this.checkShowAddBtn();
                _this.checkLabelPainterDisable();
                // Interactive fishbone
                _this.checkInteractiveFishboneDisable();
                // Topo mode
                // this.checkShowTopoModeToggle();
            }
        });
        this.mapMoveendSub = this.mapService.mapMoveendSubject.subscribe(function () {
            if (isInit) {
                return;
            }
            var map = _this.map;
            var reso = map.olMap.getView().getResolution();
            _this.mapReso = reso;
            // this.zoomLevel = this.mapService.map.olMap.getView().getZoom().toFixed(1); // + '; reso: ' + this.mapService.map.olMap.getView().getResolution();
            var showLabel = _this.checkShowLabelPainter();
            if (showLabel !== _this.showLabelPainter) {
                _this.showLabelPainter = showLabel;
                _this.mapService.toggleLabelElemVisib(showLabel);
            }
            _this.checkShowInteractiveFishbone();
            _this.checkShowFlipRoad();
            _this.checkShowLineSplit();
            _this.checkShowLineMerge();
            _this.checkShowA3i();
            _this.checkShowAddressManage();
            _this.checkShowAddressRelocate();
            _this.checkShowGeomEdit();
        });
        // this.networkTopoModeSub = this.activityService.networkTopoMode.subscribe(data => {
        // 	this.isNetworkTopoOn = data.isOn;
        // });
        // this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(data => {
        // 	if (data && data.ids.length) {
        // 		this.showZoomToRecord = true;
        // 	} else {
        // 		this.showZoomToRecord = false;
        // 	}
        // 	this.checkShowFlipRoad();
        // });
        this.currentCardSub = this.activityService.currentCardBS.subscribe(function (data) {
            _this.checkShowFlipRoad();
        });
        this.editRecordListSub = this.activityService.editRecordListBS.subscribe(function (data) {
            // this.checkShowGeomEdit();
        });
        isInit = false;
    };
    FeatMapToolsComponent.prototype.setReportMapConfigs = function () {
        var _this = this;
        var isInit = true;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) { return _this.map = data; });
        this.currentCardSub = this.activityService.currentCardBS.subscribe(function (data) {
            // if (data && data.id) {
            // 	this.showZoomToRecord = true;
            // } else {
            // 	this.showZoomToRecord = false;
            // }
        });
        this.mapMoveendSub = this.iMapService.mapMoveendSubject.subscribe(function () {
            if (isInit) {
                return;
            }
        });
        isInit = false;
    };
    // private getMap() {
    // 	const map: LRSMap.Map = this.mapType === 'data' ? this.mapService.map : this.iMapService.map;
    // 	return map;
    // }
    FeatMapToolsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.contentMenuItemKeySub = this.mainDataService.contentMenuItemKeyBS.subscribe(function (data) {
            _this.contentMenuItemKey = data;
            _this.checkShowEditBtn();
        });
    };
    FeatMapToolsComponent.prototype.ngAfterViewInit = function () {
        switch (this.mapType) {
            case 'data':
                this.setDataMapConfigs();
                break;
            case 'report':
                this.setReportMapConfigs();
                break;
        }
    };
    FeatMapToolsComponent.prototype.ngOnDestroy = function () {
        this.currentCardSub.unsubscribe();
        this.mapSub.unsubscribe();
        // this.selectedRecordsSub.unsubscribe();
        if (this.mapType === 'data') {
            this.isDataSampleSub.unsubscribe();
            this.selectedLayerSub.unsubscribe();
            this.refLayerChangeSub.unsubscribe();
            this.labelPainterSub.unsubscribe();
            this.mapEditingSub.unsubscribe();
            this.mapMoveendSub.unsubscribe();
            this.mapFilterSub.unsubscribe();
            this.editRecordListSub.unsubscribe();
            // this.networkTopoModeSub.unsubscribe();
            this.contentMenuItemKeySub.unsubscribe();
        }
        else if (this.mapType === 'report') {
        }
    };
    return FeatMapToolsComponent;
}());
export { FeatMapToolsComponent };
